import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0a2e] py-12 px-4" data-id="element-284">
      <div className="max-w-5xl mx-auto" data-id="element-285">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-286">
          <div data-id="element-287">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-288">
              +300
            </div>
            <div className="text-[#B87AFF] text-sm font-semibold mt-1" data-id="element-289">
              profes confían
            </div>
          </div>
          <div data-id="element-290">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-291">
              6+6
            </div>
            <div className="text-[#B87AFF] text-sm font-semibold mt-1" data-id="element-292">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-293">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-294">
              4.9/5
            </div>
            <div className="text-[#B87AFF] text-sm font-semibold mt-1" data-id="element-295">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-296">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-297">🇦🇷</div>
            <div className="text-[#B87AFF] text-sm font-semibold mt-1" data-id="element-298">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-299">
          <div className="flex items-start gap-3 bg-black/40 border border-[#B87AFF]/20 rounded-xl p-4" data-id="element-300">
            <div className="w-10 h-10 rounded-full bg-[#B87AFF]/20 flex items-center justify-center text-[#B87AFF] font-black text-sm flex-shrink-0" data-id="element-301">
              MR
            </div>
            <div data-id="element-302">
              <div className="text-[#B87AFF] text-xs mb-1" data-id="element-303">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-304">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para los 4 niveles."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-305">
                — María Rosa, Buenos Aires | Profesora de Yoga en Estudio Propio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#B87AFF]/20 rounded-xl p-4" data-id="element-306">
            <div className="w-10 h-10 rounded-full bg-[#B87AFF]/20 flex items-center justify-center text-[#B87AFF] font-black text-sm flex-shrink-0" data-id="element-307">
              JC
            </div>
            <div data-id="element-308">
              <div className="text-[#B87AFF] text-xs mb-1" data-id="element-309">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-310">
                "24 secuencias con progresión real. Los alumnos avanzan clase a
                clase y se nota. Nunca más improvisar."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-311">
                — Jorge C., Rosario | Profesor de Yoga en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#B87AFF]/20 rounded-xl p-4" data-id="element-312">
            <div className="w-10 h-10 rounded-full bg-[#B87AFF]/20 flex items-center justify-center text-[#B87AFF] font-black text-sm flex-shrink-0" data-id="element-313">
              SV
            </div>
            <div data-id="element-314">
              <div className="text-[#B87AFF] text-xs mb-1" data-id="element-315">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-316">
                "Adapto el mismo contenido a todos los niveles en 5 minutos.
                Antes me llevaba horas de un domingo."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-317">
                — Sofía V., Córdoba | Profesora de Yoga Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}